/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * OK
 */
export type GetCurrencyResponseBody = {
  currency: string;
};

/** @internal */
export const GetCurrencyResponseBody$inboundSchema: z.ZodType<
  GetCurrencyResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  currency: z.string(),
});
/** @internal */
export type GetCurrencyResponseBody$Outbound = {
  currency: string;
};

/** @internal */
export const GetCurrencyResponseBody$outboundSchema: z.ZodType<
  GetCurrencyResponseBody$Outbound,
  z.ZodTypeDef,
  GetCurrencyResponseBody
> = z.object({
  currency: z.string(),
});

export function getCurrencyResponseBodyToJSON(
  getCurrencyResponseBody: GetCurrencyResponseBody,
): string {
  return JSON.stringify(
    GetCurrencyResponseBody$outboundSchema.parse(getCurrencyResponseBody),
  );
}
export function getCurrencyResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetCurrencyResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetCurrencyResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetCurrencyResponseBody' from JSON`,
  );
}
